import { render } from "./SendMessage.vue?vue&type=template&id=6f9f16a8"
const script = {}

import exportComponent from "/home/forge/virtualcp.app/releases/20250710180701/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__